export const isSearchParamRegisterId = (searchParams: URLSearchParams, registerId: string | null): boolean => {
  return (
    !!searchParams.get('registerId') &&
    !!registerId &&
    searchParams.get('registerId')?.toLocaleLowerCase() === registerId?.toLocaleLowerCase()
  );
};
